// extracted by mini-css-extract-plugin
module.exports = {"header":"Header_header__1cM8q","main":"Header_main__2j1qj"};